export function getSearchText(text: string) {
  let searchText = text
    .split(' ')
    .filter((t) => t)
    .join('*')

  searchText = searchText + ':*'
  return searchText
}
